import { render, staticRenderFns } from "./OaRelatedApprovalSelect.vue?vue&type=template&id=7cb211ab&scoped=true"
import script from "./OaRelatedApprovalSelect.vue?vue&type=script&lang=js"
export * from "./OaRelatedApprovalSelect.vue?vue&type=script&lang=js"
import style0 from "./OaRelatedApprovalSelect.vue?vue&type=style&index=0&id=7cb211ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb211ab",
  null
  
)

export default component.exports